import * as Api from '../api/src'
import moment from 'moment';
export const commonfn = {
    getActiveName: (status?: Api.StatesEnum): string => {
        if (!status) {
            return '';
        }
        return status as any;
    },
    getListYears: () => {
        let years: any[] = [];
        for (let index = 2020; index <= (new Date().getFullYear() + 4); index++) {
            years.push(index);
        }
        return years;
    },
    validateEmail: (email: string) => {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.match(validRegex)) {
            return true;
        } else {
            return false;
        }
    },
    getTestStatus: (item?: Api.Test): string => {
        /* let now = new Date(moment().format("MM/DD/YYYY"));
        let expire = !!item?.ExpiredDate ? new Date(item?.ExpiredDate) : null;
        if (expire) {
            if ((now.getTime() > expire.getTime())) {
                return Api.TestStatusQueryEnum.Expired.toString();
            }
        } */
        if (item?.IsApproved) {
            return Api.TestStatusQueryEnum.Approved.toString();
        } else {
            return Api.TestStatusQueryEnum.OnGoing.toString();
        }
    },
    getProductAssignStatus: (IsApproved: boolean): string => {
        if (IsApproved) {
            return Api.TestStatusQueryEnum.Approved.toString();
        } else {
            return Api.TestStatusQueryEnum.OnGoing.toString();
        }
    },
    getModuleStatus: (item?: any): string => {
        let now = new Date(moment().format("MM/DD/YYYY"));
        let expire = !!item?.Deadline ? new Date(item?.Deadline) : null;
        if (item?.IsApproved) {
            return Api.TestStatusQueryEnum.Approved.toString();
        } else {
            if (expire) {
                if ((now.getTime() > expire.getTime())) {
                    return "OverDue";
                }
            }
        }
        return Api.TestStatusQueryEnum.OnGoing.toString();
    },
    getNameInitial: (item: any) => {
        if (!item) {
            return "SG";
        } else {
            const arr = item.split(" ");
            return arr[0][0] + (arr[1] ? arr[1][0] : "");
        }
    },
    getParramUrl: (url_string: string, paramName: string) => {
        if (!url_string) return "";
        var url = new URL(url_string);
        var c = url.searchParams.get(paramName);
        return c;
    }
}
export const TestService = {
    allowEditTest: (item: Api.Test): boolean => {
        if (item) {
            let status = commonfn.getTestStatus(item);
            let res = (status == Api.TestStatusQueryEnum.OnGoing.toString() && !item?.IsApproved);
            return res;
        } else {
            return false;
        }
    },
    allowApproveTest: (item: Api.Test): boolean => {
        if (item?.IsApproved == undefined) return false;
        return !item?.IsApproved;
    },
    isExpired: (item: Api.Test): boolean => {
        return moment(item.ExpiredDate) <= moment(moment().format('YYYY-MM-DD'));
    },
    allowDeleteTest: (item: Api.Test): boolean => {
        if (item) {
            let status = commonfn.getTestStatus(item);
            let res = !(status != Api.TestStatusQueryEnum.OnGoing.toString() && item?.IsApproved);
            return res;
        } else {
            return false;
        }
    },
}

